import styles from "./Callout.module.css";

interface CalloutProps {
  text: string;
}

const Callout = ({ text }: CalloutProps) => {
  return <div className={styles.callout}>{text}</div>;
};

export default Callout;
